import { BibliographicResource } from './bibliographic-resource';
import { BibliographicResourceType } from './bibliographic-resource-types';

export enum OnlineResourceUrlType {
  DOI = 'doi',
  DIGITISATION = 'digitisation',
  EBOOK = 'ebook',
  OPEN_ACCESS = 'open_access',
  OPENURL = 'openurl',
  WEB = 'web',
}

export const OnlineResourceUrlTypes: OnlineResourceUrlType[] = Object.keys(
  OnlineResourceUrlType,
).map(key => OnlineResourceUrlType[key]);

export enum OnlineResourceGoogleBooksType {
  GOOGLE_BOOKS = 'google_books',
}

export type OnlineResourceType =
  | OnlineResourceUrlType
  | OnlineResourceGoogleBooksType;

export const OnlineResourceTypes: OnlineResourceType[] = [
  ...OnlineResourceUrlTypes,
  OnlineResourceGoogleBooksType.GOOGLE_BOOKS,
];

export interface OnlineResourceUrl {
  item_id?: string;
  type: OnlineResourceUrlType;
  original_property?: string;
  original_url: string;
  proxied_url: string;
  external_url: string;
}

export interface OnlineResourceOpenAccess extends OnlineResourceUrl {}

export interface OnlineResourceGoogleBooks {
  item_id?: string;
  type: OnlineResourceGoogleBooksType;
  isbns: string[];

  // this is filled in by the client, following successful mediation with the Google Books API
  preview_url?: string;
}

export type OnlineResource = OnlineResourceUrl | OnlineResourceGoogleBooks;

export function isOnlineResourcePreview(
  onlineResource: OnlineResource,
): boolean {
  if (!onlineResource) {
    return false;
  }
  return onlineResource.type === OnlineResourceGoogleBooksType.GOOGLE_BOOKS;
}

export const getOriginalUrl = (
  onlineResource: OnlineResource,
): string | undefined =>
  !isOnlineResourcePreview(onlineResource)
    ? (onlineResource as OnlineResourceUrl).original_url
    : undefined;

export function isOpenUrlCompatible(resource: BibliographicResource): boolean {
  return (
    resource.resource_type === BibliographicResourceType.Article ||
    resource.resource_type === BibliographicResourceType.Journal ||
    resource.resource_type === BibliographicResourceType.Proceedings ||
    resource.resource_type === BibliographicResourceType.Book ||
    resource.resource_type === BibliographicResourceType.Chapter
  );
}
